
import { mapState } from "vuex";
import {
  configGetters,
  dashboardGetters,
  dashboardActions,
  organizationsGetters,
} from "~/store/helpers";
import AddBoardModal from "@/components/DashboardModals/addBoardModal";
import AddCardModal from "@/components/DashboardModals/addCardModal";

export default {
  head() {
    return this.makeHeader(this.$t("previous_step.index"));
  },
  data() {
    return {
      isAddingBoard: false,
      loading: false,
      pusher: null,
      activeTab: null,
      editing: false,
      showButton: true,
      currentTab: null,
      organizationId: null,
      lastTabIndex: 8,
      allTabs: [],
      lastSelectedDirection: null,
    };
  },
  watch: {
    $route: {
      async handler(val) {
        console.log(`page changed handler....`, val);
        // await this.checkNavigation();
        if (val.fullPath == "/") {
          this.getBoardsForOrg();
        } else {
          this.currentTab = JSON.parse(JSON.stringify(this.tabs)).find(
            (e) => e.name == val.params.name
          );
          this.activeTab = this.currentTab.name;
          this.$router.push(`/${this.currentTab.name}`);
        }
      },
    },
    tabs(val) {
      if (val.length == 0 && !this.isAddingBoard) {
        let payload = { name: this.$t("dashboard.overview_board") };
        this.addBoard(payload);
      }
    },
    organization() {
      this.organizationId = localStorage.getItem("organizationId");
      // this.getBoardsForOrg();
    },
  },
  computed: {
    ...dashboardGetters,
    ...configGetters,
    ...organizationsGetters,
    tabs() {
      return this.getOrgBoards();
    },
    organization() {
      return this.getOrganization();
    },
  },
  async mounted() {
    await this.checkNavigation();
  },
  methods: {
    ...dashboardActions,
    async checkNavigation() {
      this.organizationId = localStorage.getItem("organizationId");
      if (this.$vianovaConfig.options.home_path) {
        if (localStorage.getItem("lastPage")) {
          this.$router.push(localStorage.getItem("lastPage"));
        } else {
          this.$router.push(this.$vianovaConfig.options.home_path);
        }
      } else {
        await this.getBoardsForOrg();
      }
    },
    createBoardForOrg() {
      let payload = {
        name: this.$t("dashboard.overview_board"),
      };
      this.createBoard({ organizationId: this.organizationId, payload }).then(
        () => {
          this.getBoardsForOrg();
        }
      );
    },
    async getBoardsForOrg() {
      this.loading =
        localStorage.getItem("previousStep") == "index" ? false : true;

      await this.getBoards({ organizationId: this.organizationId });
      this.currentTab = JSON.parse(JSON.stringify(this.tabs))[0];
      this.activeTab = this.currentTab.name;
      this.$router.push(`/${this.currentTab.name}`);
      this.loading = false;
    },
    addBoard(event) {
      this.isAddingBoard = true;
      this.$nextTick(() => {
        Array.isArray(event)
          ? event.forEach((e) => {
              this.createBoard({
                organizationId: this.organizationId,
                payload: e,
              }).then(() => {
                this.getBoardsForOrg();
              });
            })
          : this.createBoard({
              organizationId: this.organizationId,
              payload: event,
            }).then(() => {
              this.getBoardsForOrg();
            });
      });
      this.isAddingBoard = false;
    },
    updateBoardOrder(event) {
      let boardId = event.id;
      delete event.id;
      this.updateBoard({
        organizationId: this.organizationId,
        boardId,
        payload: event,
      }).then(() => {
        // return this.getBoardsForOrg();
      });
    },
    deleteCurrentBoard(boardId) {
      this.loading = true;
      this.editing = false;
      this.deleteBoard({
        organizationId: this.organizationId,
        boardId: boardId,
      }).then(() => {
        //this.getBoardsForOrg()
        this.loading = false;
      });
    },
    scrollIntoView(direction) {
      this.allTabs = this.$refs.tabs.$children[0].$children.filter(
        (e) => e.$el["_prevClass"] == "nav-item"
      );
      let el;

      direction == "left"
        ? (this.lastTabIndex -= 12)
        : (this.lastTabIndex += 12);
      direction == "right"
        ? this.lastTabIndex >= this.allTabs.length - 3
          ? ((el = this.allTabs[this.allTabs.length - 1].$el),
            (this.lastTabIndex = this.allTabs.length - 1))
          : (el = this.allTabs[this.lastTabIndex].$el)
        : this.lastTabIndex < 3
        ? ((el = this.allTabs[0].$el), (this.lastTabIndex = 0))
        : (el = this.allTabs[this.lastTabIndex].$el);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      this.lastSelectedDirection = direction;
    },
  },
  components: {
    AddBoardModal,
    AddCardModal,
  },
  middleware: "authentication",
};
